import { render, staticRenderFns } from "./envImpactAssessmentDetail.vue?vue&type=template&id=649c17e8"
import script from "./envImpactAssessmentDetail.vue?vue&type=script&lang=js"
export * from "./envImpactAssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./envImpactAssessmentDetail.vue?vue&type=style&index=0&id=649c17e8&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649c17e8')) {
      api.createRecord('649c17e8', component.options)
    } else {
      api.reload('649c17e8', component.options)
    }
    module.hot.accept("./envImpactAssessmentDetail.vue?vue&type=template&id=649c17e8", function () {
      api.rerender('649c17e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/eia/envImpactAssessmentDetail.vue"
export default component.exports